import en from './locales/en/translations.json';
import de from './locales/de/translations.json';
import es from './locales/es/translations.json';
import fr from './locales/fr/translations.json';
import el from './locales/el/translations.json';
import it from './locales/it/translations.json';
import pl from './locales/pl/translations.json';
import lt from './locales/lt/translations.json';

export const catalog = { resources: { en, de, es, fr, el, it, pl, lt } };
